module.exports = __webpack_public_path__ + "img/sfq-h6.dfe1adc6.png";